const i = {
  width: 18,
  padding: 16,
  height: 8,
  tipRadius: 2
};
export { i as arrowDimensions };